export default {
  "supporters.detail.pageTitle": "Supporters",
  "supporters.detail.heading": "Supporters",
  "supporters.detail.head.siteName": "LINK-J",

  "supporters.list.head.title": "Supporters | LINK-J",
  "supporters.list.head.description":
    "LINK-J has recruited a number of supporters, people with knowledge spanning diverse fields and whose skill sets range from research and development to management, law, and accounting. Our supporters, who include entrepreneurs and experts, participate in many of the events that we put together and offer one-on-one advice to LINK-J special members.",
  "supporters.list.head.siteName": "LINK-J",
  "supporters.list.title": "Supporters",
  "supporters.list.heading.title": "Supporters",
  "supporters.list.heading2.title": "LINK-J's Supporters",
  "supporters.list.heading.description":
    "LINK-J has recruited a number of supporters, people with knowledge spanning diverse fields and whose skill sets range from research and development to management, law, and accounting. Our supporters, who include entrepreneurs and experts, participate in many of the events that we put together and offer one-on-one advice to LINK-J special members.",
  "supporters.list.index.breadcrumbs": "Supporters",

  "supporters.bbt.detail.pageTitle": "",
  "supporters.bbt.detail.head.siteName": "",
  "supporters.bbt.list.head.title": "",
  "supporters.bbt.list.head.description": "",
  "supporters.bbt.list.head.ogDescription": "",
  "supporters.bbt.list.head.siteName": "",
  "supporters.bbt.list.title": "",
  "supporters.bbt.list.heading.title": "",
  "supporters.bbt.list.heading2.title": "",
  "supporters.bbt.list.heading.description": "",
  "supporters.bbt.list.heading.description2": "",
  "supporters.bbt.list.heading.description.note": "",
  "supporters.bbt.list.note1": "",
  "supporters.bbt.list.note2": "",
  "supporters.bbt.list.index.breadcrumbs": "",
} as const;
